<template>
  <avue-form-design
    style="position: relative; padding-bottom: 1rem; box-sizing: border-box"
    :options="options"
    :optionsdefault="optionsDefault"
    :tableFieldsList="tableFields"
    @submit="handleSubmit"
    storage
    show-avue-doc
  ></avue-form-design>
</template>
<style scoped></style>
<script>
import {
  getFormTemplateById,
  getFormTemplateByDeptId,
  getTableFieldsDataList,
  getFormTemplateByTableId,
} from "@/api/form";
export default {
  data() {
    return {
      optionsDefault: {
        column:[],
      },
      tableFields: {
        column:'',
      },
      defaultColumn: [
        // {
        //   prop: "img",
        //   type: "img",
        //   label: "默认-图片001",
        //   span: "24",
        //   display: true,
        //   noEdit: true,
        // },
        // {
        //   prop: "img-666",
        //   type: "img",
        //   label: "默认-图片002",
        //   span: "24",
        //   display: true,
        //   noEdit: true,
        // },
      ],
      options: [{}],
      pageUrl_:''
    };
  },
  created() {
    this.handleGetData();
    
    this.pageUrl_ = this.$route.query.pageUrl;
    // this.handleGetTableFieldData();
    this.tableFields = this.deepClone({});
  },
  activated() {
    this.handleGetData();
    this.pageUrl_ = this.$route.query.pageUrl;
    // this.handleGetTableFieldData();
    this.tableFields = this.deepClone({});
  },
  methods: {
    handleSubmit(val) {
      console.log(val);
    },
    handleGetTableFieldData() {
      let type = this.$route.query.type;
      let deptId = this.$route.query.deptId;
      let projectId = this.$route.query.projectId;
      getTableFieldsDataList(type, this.pageUrl_, deptId, projectId).then((res) => {
        console.log(res.data.data.fields);
        this.tableFields = res.data.data.fields;
      });
    },
    handleGetData() {
      let formId = this.$route.query.id;
      let type = this.$route.query.type;
      let deptId = this.$route.query.deptId;
      let tableid = this.$route.query.tableid;
      let self = this;
      console.log("avue-form-history===========activated");
      // self.options = { column: [] };
      // self.options = { column: self.defaultColumn };
      localStorage.removeItem("avue-form-history");
      if (formId) {
        getFormTemplateById(formId, type).then((res) => {
          console.log(res.data);
          // self.options = JSON.parse(res.data.detail);
          if (type == 2) {
            // self.options = res.data.data.extendJson;
            // self.optionsDefault = res.data.data.mainFormInfo.createJson;
            self.optionsDefault = this.deepClone({
              column:[],
              submitBtn:false,
              emptyBtn:false,
            });
            self.options = {
              column: res.data.data.extendFormInfo.createJson.fields,
            };
            // self.options = JSON.parse(res.data.data.extendJson);
          } else {
            // self.optionsDefault = res.data.data.mainFormInfo.createJson;
            self.optionsDefault = this.deepClone({
              column:[],
              submitBtn:false,
              emptyBtn:false,
            });
            self.options = {
              column: res.data.data.publicFormInfo.createJson.fields,
            };
            // self.options = JSON.parse(res.data.data.publicJson);
          }
          console.log(self.optionsDefault);
        });
      } else {
        getFormTemplateByTableId(type, tableid).then((res) => {
          console.log(res.data);
          // self.options = JSON.parse(res.data.detail);
          if (type == 2) {
            // self.options = res.data.data.extendJson;
            // self.optionsDefault = res.data.data.publicJson
            // self.optionsDefault = res.data.data.mainFormInfo.createJson;
            self.optionsDefault = this.deepClone({
              column:[],
              submitBtn:false,
              emptyBtn:false,
            });
            console.log(self.optionsDefault.column);
            if (res.data.data.publicFormInfo.createJson) {
              self.optionsDefault.column.concat(
                res.data.data.publicFormInfo.createJson.fields
              );
            }
            
    this.options = this.deepClone([]);
            // if(res.data.data.extendJson){
            //   self.options = { column: res.data.data.extendJson.columns };

            // }

            // self.options = JSON.parse(res.data.data.extendJson);
          } else {
            // self.optionsDefault = res.data.data.mainFormInfo.createJson;
            // self.optionsDefault = res.data.data.mainFormInfo.createJson;
            self.optionsDefault = this.deepClone({
              column:[],
              submitBtn:false,
              emptyBtn:false,
            });
    this.options = this.deepClone([]);
            // self.options = { column: res.data.data.publicFormInfo.columns };
            // self.options = JSON.parse(res.data.data.publicJson);
          }
          console.log(self.optionsDefault);
        });
      }
      // }
    },
  },
};
</script>
